import { AllSteps, PostCategories, PostPhaseStatuses } from '../../../Utils/Types';

export const interactionsBoxTitle = (post: any) =>
  PostCategories.MESSAGING.includes(post.type)
    ? 'POSTS.INTERACTIONS_BOX.CONTINUE_CONVERSATION'
    : 'POSTS.INTERACTIONS_BOX.GIVE_YOUR_OPINION';

export const replyBtnTextId = (post: any) =>
  PostCategories.MESSAGING.includes(post.type) ? 'BUTTONS.WRITE' : 'BUTTONS.COMMENT';

export const getPostSideHeaderTextID = (isPostClosedForParticipation: any) => {
  if (isPostClosedForParticipation) return 'POSTS.PHASES.STATES.ENDED';

  return 'POSTS.PHASES.STATES.COMING';
};

export const currentOngoingStepTypes = (post: any) =>
  post.included.steps
    .filter(
      (step: any) =>
        step.dates_status === PostPhaseStatuses.ONGOING &&
        (step.step_type !== AllSteps.IMPLEMENTATION ||
          (step.step_type === AllSteps.IMPLEMENTATION && step.open_to_citizen_and_contributor)),
    )
    .map((step: any) => step.step_type);

export const getPostSideHeaderText = (post: any, intl: any) => {
  if (!post.included.steps) return null;

  if (currentOngoingStepTypes(post)[0] === AllSteps.IMPLEMENTATION) {
    return intl.formatMessage({
      id: 'POSTS.CONSULTATIONS.POST_SIDE_PRIMARY_ACTION.IMPLEMENTATION',
    });
  }

  return intl.formatMessage({
    id: 'POSTS.CONSULTATIONS.POST_SIDE_PRIMARY_ACTION.PARTICIPATE',
  });
};
